import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { isReportAuthor } from "@components/ReportReview/hooks/useCanManageReview";
import { useMyAuth0Id } from "@components/ReportReview/hooks/useMyAuth0Id";
import { useReportReviewers } from "@components/ReportReview/hooks/useReportReviewers";
import { Reviewer } from "@components/ReportReview/reviewers";
import { useReportOptional } from "@providers/ReportProvider";

// A reviewer's status change has no socket push (only comment changes do), so the author's open panel polls for it
// on the review items' cadence.
const REVIEWERS_POLL_INTERVAL_MS = 15_000;

/** The reviewers who sent this report back, for its author only; each gets a to-fix card in Checkpoint. */
export const useToFixReviewers = (): Reviewer[] => {
  const report = useReportOptional()?.report;
  const myId = useMyAuth0Id();
  const isAuthor = isReportAuthor(report, myId);
  const { reviewers } = useReportReviewers({ refetchInterval: isAuthor ? REVIEWERS_POLL_INTERVAL_MS : undefined });
  if (!isAuthor) return [];
  // The author's own reviewer row never sends the report back to them (matches useReviewChip).
  return reviewers.filter(
    ({ status, reviewer }) => status === ReportReviewerStatus.ChangesRequested && !!reviewer && reviewer.id !== myId,
  );
};
